/**
 * TTS Studio localized copy — TTSLayoutEnhanced, TTSLeftPanelSteps,
 * and their sibling components (SettingsTab, HistoryTabEnhanced,
 * GlobalSettingsTab, SSMLHelper, GeminiStudioControls,
 * GeminiDirectorPanel, HighlightedTextDisplay, EmotionTagsWarning /
 * EmotionTagsReviewModal, ProcessingModeSelector,
 * UnknownWordsReviewModal, VoiceSelection, ModelSelection).
 *
 * Batches:
 *   1. TTSLayoutEnhanced visible-on-load (header, tabs, banners,
 *      upload section, break-tag tip, studio tip).
 *   Further batches append to this namespace as they're localized.
 *
 * Re-export shim over /locales/{en,ht,fr,es}.json (tts_studio key).
 */
import en from '../locales-shared/en.json'
import ht from '../locales-shared/ht.json'
import fr from '../locales-shared/fr.json'
import es from '../locales-shared/es.json'
import ptBR from '../locales-shared/pt-BR.json'
import zhHans from '../locales-shared/zh-Hans.json'

const COPY = {
  en: en.tts_studio,
  ht: ht.tts_studio,
  fr: fr.tts_studio,
  es: es.tts_studio,
  'pt-BR': ptBR.tts_studio,
  'zh-Hans': zhHans.tts_studio,
}

export default COPY
